// src/pages/Appointments/Admin/VisitTracking/CheckInModal.jsx
import React, { useState } from "react";
import { FiCheckCircle, FiUser, FiClock, FiMapPin } from "react-icons/fi";
import Button from "../../../../components/common/Button";

const CheckInModal = ({ appointment, onClose, onCheckIn, loading }) => {
  const [checkInData, setCheckInData] = useState({
    method: "ADMIN",
    notes: "",
  });

  const handleSubmit = () => {
    onCheckIn(checkInData);
  };

  const checkInMethods = [
    { value: "ADMIN", label: "Manual Check-in", icon: FiUser },
    { value: "QR_CODE", label: "QR Code Scan", icon: FiCheckCircle },
    { value: "APP", label: "Mobile App", icon: FiUser },
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        {/* Header */}
        <div className="p-6 border-b">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
              <FiCheckCircle className="text-green-600 text-2xl" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-text">Check In Customer</h3>
              <p className="text-sm text-neutral-dark">
                Confirm customer arrival
              </p>
            </div>
          </div>
        </div>

        {/* Customer Info Summary */}
        <div className="p-6 bg-neutral-light">
          <div className="space-y-2 text-sm">
            <div className="flex items-center gap-2">
              <FiUser className="text-neutral-dark" />
              <span className="font-medium">{appointment.userName}</span>
            </div>
            <div className="flex items-center gap-2">
              <FiClock className="text-neutral-dark" />
              <span>
                {new Date(appointment.scheduledDateTime).toLocaleString(
                  "en-IN",
                  {
                    dateStyle: "medium",
                    timeStyle: "short",
                  }
                )}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <FiMapPin className="text-neutral-dark" />
              <span>{appointment.branchCode}</span>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="p-6 space-y-4">
          {/* Check-in Method */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Check-in Method
            </label>
            <div className="grid grid-cols-1 gap-2">
              {checkInMethods.map((method) => {
                const Icon = method.icon;
                return (
                  <label
                    key={method.value}
                    className={`flex items-center gap-3 p-3 border-2 rounded-lg cursor-pointer transition-all ${
                      checkInData.method === method.value
                        ? "border-green-500 bg-green-50"
                        : "border-gray-200 hover:border-green-300"
                    }`}
                  >
                    <input
                      type="radio"
                      name="method"
                      value={method.value}
                      checked={checkInData.method === method.value}
                      onChange={(e) =>
                        setCheckInData({
                          ...checkInData,
                          method: e.target.value,
                        })
                      }
                      className="text-green-600 focus:ring-green-500"
                    />
                    <Icon className="text-xl text-neutral-dark" />
                    <span className="font-medium">{method.label}</span>
                  </label>
                );
              })}
            </div>
          </div>

          {/* Notes */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Check-in Notes (Optional)
            </label>
            <textarea
              value={checkInData.notes}
              onChange={(e) =>
                setCheckInData({ ...checkInData, notes: e.target.value })
              }
              rows="3"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="Any special notes or observations..."
            />
          </div>

          {/* Current Time Display */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <p className="text-sm text-blue-800">
              <span className="font-medium">Check-in Time:</span>{" "}
              {new Date().toLocaleString("en-IN", {
                dateStyle: "medium",
                timeStyle: "short",
              })}
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="p-6 border-t flex gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={loading}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            loading={loading}
            className="flex-1 bg-green-600 hover:bg-green-700"
          >
            <FiCheckCircle className="mr-2" />
            Check In
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckInModal;
